import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Input } from '@ui/components/Input';
import { phoneMask } from '@features/club/ui/ClubFormInput/phone-mask';
import { ClubAdminDto } from '@features/shared/api/typings';
import { validateEmail } from '@utils/formValidations';

export function AdminInput() {
  const { control } = useFormContext<{ administrator: ClubAdminDto }>();
  return (
    <>
      <FormRow>
        <FormLabel>Имя администратора</FormLabel>
        <FormInput>
          <Controller
            name="administrator.fullName"
            control={control}
            render={({ field: { value, onChange, disabled } }) => (
              <Input invisible value={value as string} onChange={onChange} disabled={disabled} />
            )}
          />
        </FormInput>
      </FormRow>

      <FormRow>
        <FormLabel>Телефон администратора</FormLabel>
        <FormInput>
          <Controller
            name="administrator.phoneNumber"
            control={control}
            render={({ field: { value, onChange, disabled } }) => (
              <Input invisible value={value as string} onChange={v => onChange(phoneMask(v))} disabled={disabled} />
            )}
          />
        </FormInput>
      </FormRow>

      <FormRow>
        <FormLabel>E-mail администратора</FormLabel>
        <FormInput>
          <Controller
            name="administrator.email"
            control={control}
            rules={{
              validate: validateEmail,
            }}
            render={({ field: { value, onChange, disabled } }) => (
              <Input invisible value={value as string} onChange={onChange} disabled={disabled} />
            )}
          />
        </FormInput>
      </FormRow>
    </>
  );
}
